var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('baseInfo',{attrs:{"orderBean":_vm.orderBean,"isEdit":""}}),_c('orderFeature'),_c('purchaseSum')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }